import { useState, useCallback } from 'react';

export function useToast(ms = 2800) {
  const [toast, setToast] = useState({ visible: false, message: '', type: 'success' });
  const show = useCallback((message, type = 'success') => {
    setToast({ visible: true, message, type });
    setTimeout(() => setToast(t => ({ ...t, visible: false })), ms);
  }, [ms]);
  return { toast, show };
}

export function useGreeting() {
  const h = new Date().getHours();
  return h < 12 ? 'Buenos días' : h < 18 ? 'Buenas tardes' : 'Buenas noches';
}
